import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { DataService } from 'src/app/data.service';
import { LocalStorageService } from '../../services/storage/local-storage.service';
import { KEYS } from '../../utils/constants/storage.constants';
import { AuthService } from '../../services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class LangGuard implements CanActivate {
  constructor(
    private router: Router,
    private readonly dataService: DataService,
    private readonly localStorage: LocalStorageService,
    private readonly authService: AuthService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const isFirstLaunch = this.localStorage.getItem(KEYS.IS_FIRST_LAUNCH);

    if (!isFirstLaunch || !isFirstLaunch?.length) {
      const redirectPath = 'onboarding';
      this.router.navigate([redirectPath]);
      return false;
    }

    const redirectPath =
      route.data['redirectPath'] || 'new-preferred-language-selection';
    const skipPreferredLanguageSelection =
      this.dataService.skipPreferredLanguageSelection;

    if (skipPreferredLanguageSelection) {
      return true;
    }

    this.router.navigate([redirectPath], {
      queryParams: { isFirstTime: true },
    });
    return false;
  }
}
